import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'vdo-map-cluster-icon',
  imports: [CommonModule],
  templateUrl: './vdo-map-cluster-icon.component.html',
  styleUrl: './vdo-map-cluster-icon.component.scss',
})
export class VdoMapClusterIconComponent {
  size = input(0, {
    transform: (value: string) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    },
  });

  readonly clusterColor = computed(() => {
    const currentClusterSize = this.size();
    if (currentClusterSize < 10) return 'cluster-marker__green';
    if (currentClusterSize < 100) return 'cluster-marker__yellow';
    return 'cluster-marker__orange';
  });
}
